import { render, staticRenderFns } from "./AlbumListItem.vue?vue&type=template&id=0d9a903b&scoped=true&"
import script from "./AlbumListItem.vue?vue&type=script&lang=js&"
export * from "./AlbumListItem.vue?vue&type=script&lang=js&"
import style0 from "./AlbumListItem.vue?vue&type=style&index=0&id=0d9a903b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9a903b",
  null
  
)

export default component.exports